import noop from 'lodash/noop';

import { isTouchOnly } from 'atg/utils/device';
import * as Utils from 'atg/utils/Utils';
import {
  PLACE_BET_ATG,
  PLACE_BET_ATG_TILLSAMMANS,
  PLACE_BET_CANCEL,
  PLACE_BET_DOWNLOAD_FILE,
} from 'shared/constants/TrackingConstants';
import { trackUser } from 'shared/redux/actions';
import { getStore } from 'shared/redux/store';
import { formatDateCompact } from 'shared/utils/dateUtils';
import { formatMoney } from 'shared/utils/money';
import { getText } from 'shared/utils/Text';

import Dialog from './Dialog';

const $ = window.$;

export default class ExportDialog extends Dialog {
  constructor(delegate, responseData, onClose = noop) {
    super('dialog-export', null, delegate);

    this.onClose = onClose;
    this.onButtonPressed = this.onButtonPressed.bind(this);
    this.$container.find('a.active').event('click', this.onButtonPressed);
    this.$container.find('button').event('click', this.onButtonPressed);
    this._init(responseData);
    this.dispatch = getStore().dispatch;
  }

  _dispatchTrackEvent(eventName) {
    const api = this.getAPI();
    const betKey = api.betInformation.getBetKey();

    new Promise((resolve, reject) => {
      api.loadBetKeyInfo(betKey, betKeyInfo => {
        if (betKeyInfo) {
          resolve(betKeyInfo);
        } else {
          reject();
        }
      });
    }).then(
      betKeyInfo => {
        const gameType = betKey.getBetType();
        const price = api.getStake().getStake();
        const formattedPrice = formatMoney(price.getSum(), price.getCurrency());
        const track = betKeyInfo.getTrack().getName();
        const date = betKeyInfo.getTime();

        getStore().dispatch(
          trackUser(eventName, {
            gameType,
            closeTime: date.toISOString(),
            stake: formattedPrice,
            round: `${gameType}-${track}-${formatDateCompact(date)}`,
          }),
        );
      },
      () => {
        // Skip tracking on failure
      },
    );
  }

  _init(responseData) {
    const { xml, missingHorses } = responseData;

    Utils.insertTexts(this.$container);

    const $text = this.$container.find('.text');
    const $popupWarning = this.$container.find('.popup-warning');
    const $warnings = this.$container.find('.warnings');
    const $positiveButton = this.$container.find('#download');
    const $positiveLabel = this.$container.find('#download .label');

    const $apiLabel = this.$container.find('#api .label');

    const $tillsammansLabel = this.$container.find('#tillsammans .label');

    const $underButtons = this.$container.find('#under-buttons');
    const $mobileXMLInput = this.$container.find('#xmlinput');
    const $mobileXMLInputTS = this.$container.find('#xmlinput_ts');

    const $negativeLabel = this.$container.find('#cancel .label');

    // check missing horses

    if (!missingHorses) {
      this.$container.find('.has-warnings').remove();
    } else {
      const { missingHorsesLegs } = missingHorses;
      const legNumbers = Object.keys(missingHorsesLegs);

      if (legNumbers.length > 0) {
        let html = getText('dialog-export-warning-horses-without-marks');
        html += '<br/>';

        for (const [key, value] of Object.entries(missingHorsesLegs)) {
          html += getText(
            'dialog-export-warning-horses-without-marks-leg',
            key,
            value.join(', '),
          );
          html += '<br/>';
        }

        $warnings.append($('<p/>').html(html));
      }
    }

    $negativeLabel.text(getText('dialog-export-button-cancel'));

    const xmlstr = xml; //xml.xml ? xml.xml : (new XMLSerializer()).serializeToString(xml);
    $mobileXMLInput.val(xmlstr);
    $mobileXMLInputTS.val(xmlstr);

    if (isTouchOnly()) {
      $popupWarning.html(getText('dialog-export-text-mobile'));
      $apiLabel.text(getText('dialog-export-button-play-api-mobile'));
      $tillsammansLabel.text(getText('dialog-export-button-play-tillsammans'));
      $positiveButton.remove();
      $underButtons.remove();
    } else {
      $text.html(getText('dialog-export-text'));
      $positiveLabel.text(getText('dialog-export-button-play'));
      $apiLabel.text(getText('dialog-export-button-play-api'));
      $popupWarning.html(getText('dialog-export-popup-warning'));
      $tillsammansLabel.text(getText('dialog-export-button-play-tillsammans'));
    }

    this.$container.find('FORM').event('submit', e => {
      this._dispatchTrackEvent(
        e.currentTarget.action.includes('tillsammans.atg.se')
          ? PLACE_BET_ATG_TILLSAMMANS
          : PLACE_BET_ATG,
      );

      this.onClose(true);
      this.close();
    });
  }

  onButtonPressed(event) {
    const eventValue = $(event.currentTarget).data('value');
    this._dispatchTrackEvent(
      eventValue === 2 ? PLACE_BET_DOWNLOAD_FILE : PLACE_BET_CANCEL,
    );
    this.onClose(eventValue);
    this.close();
  }

  willCloseFromOutside() {
    this._dispatchTrackEvent(PLACE_BET_CANCEL);
    this.onClose(false);
  }
}
